
define(
	'EideBaillyLLP.ProductProposition65Warning'
,   [
		'ProductProp65Warning.View'
	]
,   function (
		ProductProp65WarningView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			/**
			* @type {ProductDetailsComponent}
			*/
			var pdp = container.getComponent('PDP');
			
			if (pdp) {
				pdp.on('beforeShowContent', function() {
					try {
						var isDisplayProp65Warning = pdp.getItemInfo().item.custitem_apco_display_prop65_warning;
						
						pdp.addChildViews(
							pdp.PDP_FULL_VIEW,
							{
								'StockDescription': {
									'Proposition65WarningView': {
										childViewIndex: 6,
										childViewConstructor: function() {
											return new ProductProp65WarningView({
												isDisplayProp65Warning: isDisplayProp65Warning
											});
										}
									}
								}
							}
						);
					} catch (e) {
						console.error(e);
					}
				});
			}
		}
	};
});
